var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCommissionStaffBg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 111,
    viewBox: "0 0 114 111",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.4262 0C96.6367 7.21427 98.9481 15.9888 101.376 25.2053C102.315 28.7713 103.272 32.4035 104.363 36.0371C105.289 39.1212 106.31 42.2096 107.325 45.2774C111.389 57.569 115.344 69.5281 112.618 79.5446C109.212 92.061 95.3749 101.544 81.1268 110.371C80.782 110.581 80.437 110.791 80.0918 111H34C15.2223 111 0 95.7777 0 77V34C0 15.2223 15.2223 0 34 0H92.4262Z",
    fill: "#C1D1FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommissionStaffBg);
export default __webpack_public_path__ + "static/media/commissionStaffBG.6931c5b62a4cd73bb425d6bb4a95fae4.svg";
export { ForwardRef as ReactComponent };